import { createTransform } from 'redux-persist'
import { createWhitelistFilter } from 'redux-persist-transform-filter'

export const AuthTransform = createTransform(
    // transform state on its way to being serialized and persisted.
    (inboundState, key) => {
        // convert mySet to an Array.
        return {
            ...inboundState,
            error: null,
            loading: false
        }
    },
    // transform state being rehydrated
    (outboundState, key) => {
        // convert mySet back to a Set.
        return { ...outboundState }
    },
    // define which reducers this transform gets called for.
    { whitelist: ['auth'] }
)

export const AuthFilter = createWhitelistFilter('auth', ['access_token', 'expires_at'])
